import { OrderReceipt } from "../components/types"

export const calculateYieldPacking = (rows: OrderReceipt[], expectAmount: number) => {
  if (expectAmount === 0) return 0

  const actualOutput = rows.reduce((acc, row) => acc + row.totalAmount!, 0) // Note : FG unit

  const yieldTolerance = actualOutput * 100 / expectAmount

  return yieldTolerance
}

export const calculateYieldFilling = (row: OrderReceipt) => {
  const actualOutput = row.totalAmount || 0 // Note : EA unit

  const avgFillingWeight = row.avgFillingWeight ? row.avgFillingWeight/1000 : 0

  const bulkUsage = row.bulkUsage || 0

  if (bulkUsage === 0) return 0

  const yieldTolerance = actualOutput * avgFillingWeight / bulkUsage * 100

  return yieldTolerance
}

// TODO - yield for BULK order add here